<div class="core-part-dialog">
  <div class="core-part-dialog-header flex-between-center">
    <p class="m-0 font-bold d-flex align-self-center">
      <i class="far fa-undo font-20 pr-2 font-gray-45"></i>
      <span>{{data.returnType === 'item'? 'Return' : 'Core'}} tracking</span>
    </p>

    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="core-part-dialog-body flex-column">
    <!-- Item name -->
    <div class="ui-g-12 field-wrapper-with-bg edit-field">
      <div class="ui-g-12 p-0 flex-start-center">
        <div class="icon flex-center-start">
          <i class="far fa-tools height-icon"></i>
        </div>

        <div class="width-100p position-relative cost-field">
          <app-input id="core-part-return-title" type="text" placeholder="Item name*" theme="light" [fontSize]="14"
            [floatingLabel]="true" [value]="item?.title" [disabled]="true"> </app-input>
        </div>
      </div>
    </div>

    <!-- Basic info -->
    <div class="ui-g-12 p-0">
      <h5 class="input-heading">Basic info</h5>
    </div>

    <div class="ui-g-12 p-0 input-default-style mb-0">
      <!-- Item number -->
      <div class="ui-g-4 pl-0">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.code }">
          <div class="icon flex-center-start">
            <i class="far fa-qrcode height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-part-return-code" type="text" placeholder="Item number*" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.code" [disabled]="true"> </app-input>
          </div>
        </div>
      </div>

      <!-- Category -->
      <div class="ui-g-4">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.category?.name }">
          <div class="icon flex-center-start">
            <i class="far fa-tags height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-part-return-category" type="text" placeholder="Category*" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.category?.name" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Supplier -->
      <div class="ui-g-4 pr-0">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.supplier?.name }">
          <div class="icon flex-center-start">
            <i class="far fa-warehouse height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-part-return-supplier" type="text" placeholder="Supplier*" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.supplier?.name" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>
    </div>

    <!-- Pricing -->
    <div class="ui-g-12 p-0">
      <h5 class="input-heading">Pricing</h5>
    </div>

    <div class="ui-g-12 p-0 input-default-style mb-0">
      <!-- Cost -->
      <div class="ui-g-4 pl-0">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.cost }">
          <div class="icon flex-center-start">
            <i class="far fa-receipt height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-part-return-cost" type="text" placeholder="Cost*" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.cost || 0 | currency: usd" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Default qty -->
      <div class="ui-g-4">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.count }">
          <div class="icon flex-center-start">
            <i class="far fa-boxes height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-part-return-qty" type="text" placeholder="Default Qty" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.count || 0 | number: '1.2-2'" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Total cost -->
      <div class="ui-g-4 pr-0 flex-start-center">
        <div class="field-wrapper-with-bg flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-receipt height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field" [ngClass]="{ empty: !item?.totalCost }">
            <app-input id="core-part-return-total-cost" type="text" placeholder="Total cost" theme="light"
              [fontSize]="14" [floatingLabel]="true" [value]="item?.totalCost || 0 | currency: usd" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>
    </div>

    <!-- Additional detail -->
    <div class="ui-g-12 p-0">
      <h5 class="input-heading">Additional details</h5>
    </div>

    <div class="input-default-style mb-0">
      <div class="ui-g-12 pl-0 pr-0">
        <div class="field-wrapper-with-bg editable flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-sticky-note height-icon"></i>
          </div>

          <div class="w-100 pl-1 pr-2 position-relative cost-field" [ngClass]="{ empty: !item?.totalCost }">
            <app-textarea class="w-100" textAreaId="core-part-return-desc" theme="light" placeholder="Part description"
              [floatingLabel]="true" [autoGrow]="true" [maxAutoGrowHeight]="64" [fontSize]="14" [rows]="2"
              [value]="item?.description" [value]="part.description">
            </app-textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- Order Details -->
    <div class="order-detail-wrapper">
      <div class="ui-g-12 p-0">
        <h5 class="input-heading mb-2">Order details</h5>
      </div>

      <div class="ui-g-12 p-0 input-default-style">
        <!-- Qty ordered -->
        <div class="ui-g-6 p-0 flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-boxes height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="qty-ordered" type="text" placeholder="Qty ordered" theme="light" [selectTextOnFocus]="true"
              [value]="focus?.qtyOrdered ? item?.qtyOrdered : item?.qtyOrdered" [mask]="focus?.qtyOrdered ? '0*' : ''"
              [fontSize]="14" [floatingLabel]="true" [value]="item?.qtyOrdered"
              [disabled]="['PartsTech', 'Nexpart'].includes(item?.itemSource)" (appFocus)="handleFocus('qtyOrdered')"
              (appBlur)="handleBlur('qtyOrdered')" (appChange)="handleChange('qtyOrdered', $event)">
            </app-input>
          </div>
        </div>

        <!-- Supplier invoice -->
        <div class="ui-g-6 p-0 flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-file-invoice-dollar height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="supplier-invoice" type="text" placeholder="Supplier's invoice #" theme="light"
              [maxLength]="25" [fontSize]="14" [floatingLabel]="true" [value]="item?.supplierInvoiceNo"
              (appChange)="handleChange('supplierInvoiceNo', $event)">
            </app-input>
          </div>
        </div>
      </div>

      <ng-container *ngIf="data.returnType === 'item' else coreTrackingSection">
        <div class="ui-g-12 p-0">
          <h5 class="input-heading mb-2">Return details</h5>
        </div>

        <div class="ui-g-12 p-0 input-default-style">
          <!-- Qty return -->
          <div class="ui-g-6 p-0 flex-start-center">
            <div class="icon flex-center-start">
              <i class="far fa-boxes height-icon"></i>
            </div>

            <div class="width-100p pl-1 pr-2 position-relative cost-field">
              <app-input id="qty-returned" type="text" placeholder="Qty returned" theme="light"
                [autoFocus]="focus?.itemReturnQty" [selectTextOnFocus]="true"
                [value]="focus?.itemReturnQty ? item?.itemReturnQty : item?.itemReturnQty"
                [mask]="focus?.itemReturnQty ? '0*' : ''" [fontSize]="14" [floatingLabel]="true"
                [value]="item?.itemReturnQty" [isInvalid]="errors?.itemReturnQty" [errorMessage]="errors?.itemReturnQty"
                (appFocus)="handleFocus('itemReturnQty')" (appBlur)="handleBlur('itemReturnQty')"
                (appChange)="handleChange('itemReturnQty', $event)">
              </app-input>
            </div>
          </div>

          <!-- Return date -->
          <div class="ui-g-6 p-0 flex-start-center">
            <div class="icon flex-center-start">
              <i class="far fa-calendar-alt height-icon"></i>
            </div>

            <div class="width-100p pl-1 pr-2 position-relative cost-field return-date" #startDateCalendarContainer>
              <div class="float-static-labl">
                Return date
              </div>
              <div class="calendar-input core-calendar">
                <p-calendar id="start-date" dateFormat="M dd, yy" [(ngModel)]="item.returnDate" #startDateCalendar>
                </p-calendar>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #coreTrackingSection>
        <div class="ui-g-12 p-0">
          <h5 class="input-heading mb-2">Core tracking</h5>
        </div>

        <div class="ui-g-12 p-0 input-default-style">
          <!-- Core tracking -->
          <div class="ui-g-6 p-0 flex-start-center">
            <div class="icon flex-center-start">
              <i class="far fa-tools height-icon"></i>
            </div>

            <div class="width-100p pl-1 pr-2 position-relative cost-field">
              <app-input id="core-tracking-cost" type="text" placeholder="Cost" theme="light"
                value="{{focus?.coreCost ? item?.coreCost : item?.coreCost | currency: usd}}"
                [autoFocus]="focus?.coreCost" [selectTextOnFocus]="true" [fontSize]="14" [floatingLabel]="true"
                [allowDecimal]="focus?.coreCost" [value]="item?.coreCost" [isInvalid]="errors?.coreCost"
                [errorMessage]="errors?.coreCost" [disabled]="['TireHub', 'TireConnect'].includes(item?.itemSource)"
                (appFocus)="handleFocus('coreCost')" (appBlur)="handleBlur('coreCost')"
                (appChange)="handleChange('coreCost', $event)">
              </app-input>
            </div>
          </div>

          <!-- Core retrieval status -->
          <div class="ui-g-6 p-0 flex-start-center">
            <div class="icon flex-center-start">
              <i class="far fa-ballot-check height-icon"></i>
            </div>

            <div class="width-100p pl-1 pr-2 position-relative cost-field">
              <app-dropdown id="core-retrieval-status" listId="core-retrieval-status-list" field="label"
                scrollHeight="100px" theme="light" styleClassSelectedView="pl-0" styleClassValue="pl-0"
                label="Core retrieval status" placeholder="Core retrieval status" position="top" [floatingLabel]="true"
                [setPositionDynamically]="false" [options]="coreRetrievalStatus" [isDropdownIconVisible]="true"
                [fontSize]="14" [value]="item?.coreRetrievalStatus" [listItemFontSize]="12"
                (appSelect)="handleChange('coreRetrievalStatus', $event)">
              </app-dropdown>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="core-part-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>

    <button class="btn btn-primary btn-submit" (click)="handleSave()">
      <span [ngClass]="{'pr-2': isSaving}">Save</span>
      <i class="fal fa-spinner rotate" *ngIf="isSaving"></i>
    </button>
  </div>
</div>
